<template>
    <div class="grid flex-grow-1">
        <div class="col flex-column sm:flex-row flex justify-content-between align-items-start sm:align-items-center gap-3">
            <div>
                <Inplace
                    ref="inplace"
                    :pt="{
                        root: {class: 'align-self-start'},
                        display: {class: 'inline-block', style: 'margin-left: -12px;'}
                    }"
                >
                    <template #display>
                        <div class="flex align-items-center gap-2">
                            <h3>{{ getTitle }}</h3>
                            <i class="pi pi-pencil report_title__icon_edit"></i>
                        </div>
                    </template>
                    <template #content>
                        <div class="flex flex-wrap-nowrap align-items-center report_title__field_container">
                            <AdaptersLoader :loading="loading" />
                            <InputText
                                v-model="model.title"
                                @keyup.enter="onRenameProject"
                                @keyup.esc="onClose"
                                @focusout="onClose"
                                autofocus
                                class="report_title__input_edit"
                            />
                        </div>
                    </template>
                </Inplace>
                <div class="flex column-gap-6 row-gap-2 align-items-center flex-wrap">
                    <div class="flex gap-1 align-items-center">
                        <span v-html="$t('lang.serp.report.region', [getRegionCaption])" />
                    </div>
                    <div>
                        <span v-html="$t('lang.serp.report.search_engine', [searchEngine])" />
                    </div>
                    <div>
                        <span v-html="$t('lang.serp.report.top_number', [topNumber])" />
                    </div>
                </div>
            </div>
            <SerpVersionSelector class="align-self-end sm:align-self-center" />
        </div>
    </div>
</template>

<script>
import Inplace from "primevue/inplace";
import InputText from "primevue/inputtext";
import yandexRegionsList from "../../../../../resources/yandex-regions.json";
import {ArrayHelper} from "../../../helpers/ArrayHelper";
import Button from "primevue/button";
import {Listeners} from "../../../constants/listeners";
import SerpApi from "../../../api/SerpApi";
import Alerts from "../../../mixins/Alerts";
import AdaptersLoader from "../../../component/adapters/Loader.vue";
import SerpVersionSelector from "./VersionSelector.vue";

export default {
    name: "SerpReportTitle",
    mixins: [Alerts],
    props: {
        id: {
            type: Number,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        regionId: {
            type: Number,
            required: true,
        },
        regionName: {
            type: String,
            required: true,
        },
        searchEngine: {
            type: String,
            required: true,
        },
        topNumber: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            loading: false,
            model: {
                title: this.title
            },
            currentTitle: null,
        }
    },
    mounted() {
        this.currentTitle = this.title;
    },
    computed: {
        getTitle() {
            return this.model.title;
        },
        getRegionCaption() {
            if (this.regionName) {
                return this.regionName;
            }

            const region = ArrayHelper.getObjectByAttrValue(yandexRegionsList, 'id', this.regionId);
            return region?.title ?? "";
        },
        isWordstatRegion() {
            const region = ArrayHelper.getObjectByAttrValue(yandexRegionsList, 'id', this.regionId);
            return region?.wordstat ?? false;
        }
    },
    methods: {
        onRenameProject() {
            this.loading = true;
            SerpApi
                .updateProjectName(this.id, {name: this.model.title})
                .then(() => {
                    this.currentTitle = this.model.title;
                    this.$emitter.emit(Listeners.BLOCK_BREADCRUMBS_LAST_ITEM_RENAME, this.model.title);
                    this.$refs.inplace.close();
                })
                .catch(error => this.alertError(error))
                .finally(() => this.loading = false);
        },
        onClose() {
            this.model.title = this.currentTitle;
            this.$refs.inplace.close();
        },
    },
    components: {
        AdaptersLoader,
        Inplace,
        InputText,
        Button,
        SerpVersionSelector,
    }
}
</script>

<style scoped>
.report_title__field_container {
    padding: 1px 0 0;
}
.report_title__input_edit {
    font-size: 24px;
    margin: 1px 0 0;
}
.report_title__icon_edit {
    color: var(--secondary-color);
}
</style>
